import React, { useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { setList, createList, changeList } from '../ActionsBrafab/Favourites.action'

const FavouritesMenu = () => {
    const dispatch = useDispatch();

    const {favouriteLists} = useSelector((state) => state.favourites);
    const selectedListId = favouriteLists.find(i=>i.selected)?.systemId;
    const [openCreate, SetOpenCreate] = useState(false);
    const [showInfo, SetShowInfo] = useState(false);
    const [listName, SetListName] = useState('');
    const [stateClass, setStateClass] = useState('');

    const onCreateList = (listName) => {
        setStateClass(StateStyles.LOADING)
        dispatch(createList(listName)).then(() => {
            setStateClass(StateStyles.SUCCESS);
            setTimeout(() => {
                setStateClass(StateStyles.DONE);
            }, 1000);
        })
        .catch(() => {
            setStateClass(StateStyles.ERROR);
        });
        
    }

    const StateStyles = {
        LOADING: 'buy-button--loading',
        SUCCESS: 'buy-button--success',
        ERROR: 'buy-button--error',
        DONE: ''
    };

    return (
        <>
            <div className="navbar__link favourites-wrapper" onClick={() => SetShowInfo(!showInfo)}>{translate('common.favourites.title')}</div>
            <div className={`favourites ${!showInfo ? 'favourites--hidden' : ''}`}>
                <div className="close-button" onClick={() => SetShowInfo(!showInfo)}></div>
                <select value={selectedListId??''} onChange={(event) => dispatch(changeList(event.target.value))}>
                    <option value={''} disabled>{translate('common.favourites.choose.list')}</option>
                    {favouriteLists && favouriteLists.map((list) =>
                        <option value={list.systemId} key={`favouriteList-${list.systemId}`}>{list.name}</option>
                    )}
                </select>
                <div className="favourites__buttons">
                    <button className="button favourite__button favourites__use-button" type="button" onClick={() => dispatch(setList(selectedListId,true))}>
                        {translate('common.favourites.use.list')}
                    </button>
                    <button className="button favourite__button favourites__show-button" type="button" onClick={() => dispatch(setList(selectedListId, false, window.__litium.constants.offerPageUrl))}>
                        {translate('common.favourites.show.list')}
                    </button>
                    <button className="button favourite__button favourites__create-button" type="button" onClick={() => SetOpenCreate(!openCreate)}>
                        {translate('common.favourites.create.new.list.text')}
                    </button>
                </div>
                <div className={`create-list-wrapper open-${openCreate}`}>
                    <input type="text" value={listName} onChange={(event) => SetListName(event.target.value)} placeholder={translate('common.favorites.new.list.placeholder')} />
                    <span className={stateClass}>
                        <button
                            className="buy-button button product-detail__buy-button favourites__create-button"
                            onClick={() => onCreateList(listName)}
                        >
                            {translate('common.favourites.save.list')}
                        </button>
                    </span>
                </div>
            </div>
        </>
    )
}

export default FavouritesMenu;